import { IoPerson, IoCalendarClearSharp } from "react-icons/io5";
import { BsBarChartFill, BsBookmarkFill } from "react-icons/bs";
import { LuTicket } from "react-icons/lu";
// import { IoBagSharp } from "react-icons/io5";
import { AiOutlineSchedule } from "react-icons/ai";
import { IoMdSettings } from "react-icons/io";
import { PiListBulletsFill } from "react-icons/pi";

// import { MdShoppingCart } from "react-icons/md";
// import PimsIcon from "./PimsIcon";

// main side bar 我在這
export const sideBarList = [
  {
    name: "statistics",
    path: "/statistics/consultantPerformance", // 點擊數據後會跳轉的路由
    icon: <BsBarChartFill size={24} />,
    text: "數據",
  },
  {
    name: "sales",
    path: "/sales",
    icon: <BsBookmarkFill size={24} />,
    text: "銷售",
  },
  {
    name: "customer",
    path: "/customer/list",
    icon: <IoPerson size={24} />,
    text: "會員",
  },
  {
    name: "appointment",
    path: "/appointment",
    icon: <IoCalendarClearSharp size={24} />,
    text: "預約",
  },
  {
    name: "tickets",
    path: "/tickets/ticketManagement",
    icon: <LuTicket size={24} />,
    text: "課程",
  },
  // {
  //   name: "commodity",
  //   path: "/commodity",
  //   icon: <IoBagSharp size={24} />,
  //   text: "商品",
  // },
  {
    name: "shiftschedule",
    path: "/shiftschedule/employees",
    icon: <AiOutlineSchedule size={24} />,
    text: "班表",
  },
  {
    name: "accounting",
    path: "/accounting",
    icon: <PiListBulletsFill size={24} />,
    text: "帳務",
  },
  {
    name: "pims",
    path: "/pims/",
    // icon: <MdShoppingCart size={24} />,
    // icon: <PimsIcon size={24} />,
    text: "請採驗",
  },
  {
    name: "options",
    path: "/options/company",
    icon: <IoMdSettings size={24} />,
    text: "設定",
  },
];
// sidebar
// const sideBarMenuMap = {
//   overview: [
//     {
//       value: 'overview',
//       label: '項目一',
//     },
//     {
//       value: '項目二',
//       label: '項目二',
//     },
//   ],
//   orders: [
//     {
//       value: 'orders',
//       label: '預約訂單',
//     },
//     // {
//     //   value: "商城訂單",
//     //   label: "商城訂單",
//     // },
//     // {
//     //   value: "ordersreservation",
//     //   label: "活動訂單",
//     // },
//     // {
//     //   value: "發票管理",
//     //   label: "發票管理",
//     // },
//     // {
//     //   value: "數據分析",
//     //   label: "數據分析",
//     // },
//   ],
//   customer: [
//     {
//       value: 'customer/list',
//       label: '顧客清單',
//     },
//     // {
//     //   value: "數據分析",
//     //   label: "數據分析",
//     // },

//     {
//       value: 'memberlevel',
//       label: '會員分級',
//     },
//     {
//       value: '購物金',
//       label: '購物金',
//     },
//     {
//       value: '點數',
//       label: '點數',
//     },
//   ],
//   reservation: [
//     // {
//     //   value: "reservationschedule",
//     //   label: "預約排程表",
//     // },
//     // {
//     //   value: "數據分析",
//     //   label: "數據分析",
//     // },

//     {
//       value: 'reservationform',
//       label: '排班/設定',
//     },
//   ],
//   registration: [
//     {
//       value: 'registration',
//       label: '活動列表',
//     },
//     // {
//     //   value: "數據分析",
//     //   label: "數據分析",
//     // },
//   ],
//   commodities: [
//     {
//       value: 'commodities',
//       label: '商品列表',
//     },
//     {
//       value: '預購商品列表',
//       label: '預購商品列表',
//     },
//     {
//       value: '防偽與保固管理',
//       label: '防偽與保固管理',
//     },
//     {
//       value: '加購品列表',
//       label: '加購品列表',
//     },
//     {
//       value: '贈品列表',
//       label: '贈品列表',
//     },
//   ],
//   inventory: [
//     {
//       value: '供應商',
//       label: '供應商',
//     },
//     {
//       value: '盤點單',
//       label: '盤點單',
//     },
//     {
//       value: '調撥單',
//       label: '調撥單',
//     },
//     {
//       value: '進貨單',
//       label: '進貨單',
//     },
//     {
//       value: '庫存',
//       label: '庫存',
//     },
//   ],
//   marketing: [
//     {
//       value: '第三方串通',
//       label: '第三方串通',
//     },
//     {
//       value: '廣告設定',
//       label: '廣告設定',
//     },
//     {
//       value: '分潤設定',
//       label: '分潤設定',
//     },
//     {
//       value: '促銷設定',
//       label: '促銷設定',
//     },
//   ],
//   scan: [
//     {
//       value: 'scanbook',
//       label: '預約服務',
//     },
//     {
//       value: 'scan',
//       label: '售票服務',
//     },
//   ],
//   options: [
//     {
//       value: 'options',
//       label: '設定',
//     },
//   ],
// }

// export const sideBarMenu = (page) => {
//   return sideBarMenuMap[page] || []
// }
// const sideBarTitleMap = {
//   overview: [
//     {
//       value: 'overview',
//       label: '報表及分析',
//     },
//   ],
//   orders: [
//     {
//       value: 'orders',
//       label: '訂單管理',
//     },
//   ],
//   customer: [
//     {
//       value: 'customer',
//       label: '顧客管理',
//     },
//   ],
//   reservation: [
//     {
//       value: 'reservation',
//       label: '預約管理',
//     },
//   ],
//   registration: [
//     {
//       value: 'registration',
//       label: '活動管理',
//     },
//   ],
//   commodities: [
//     {
//       value: 'commodities',
//       label: '商品管理',
//     },
//   ],
//   inventory: [
//     {
//       value: '庫存管理',
//       label: '庫存管理',
//     },
//   ],
//   marketing: [
//     {
//       value: '行銷管理',
//       label: '行銷管理',
//     },
//   ],
//   scan: [
//     {
//       value: 'scan',
//       label: 'POS機',
//     },
//   ],
//   options: [
//     {
//       value: 'options',
//       label: '品牌管理',
//     },
//   ],
// }
// export const sideBarTitle = (page) => {
//   return sideBarTitleMap[page] || []
// }
